module.exports = __webpack_public_path__ + "static/protocol-0a4d4d5c63c1e7b2fbfd462117a696b8.png";